interface FindingSummaryProps {
  open: number;
  fixed: number;
  dismissed: number;
  deferred?: number;
}

function Pill({ label, count, testId, active }: { label: string; count: number; testId: string; active: boolean }) {
  const bg = active ? (label === 'O' ? 'bg-red-900 text-red-300' : label === 'F' ? 'bg-green-900 text-green-300' : label === 'Df' ? 'bg-yellow-900 text-yellow-300' : 'bg-gray-700 text-gray-300') : 'bg-gray-800 text-gray-500';
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-mono ${bg}`}>
      <span className="font-bold">{label}</span>
      <span>{count}</span>
    </span>
  );
}

export function FindingSummary({ open, fixed, dismissed, deferred = 0 }: FindingSummaryProps) {
  return (
    <span className="inline-flex items-center gap-1">
      <Pill label="O" count={open} testId="finding-open" active={open > 0} />
      <Pill label="F" count={fixed} testId="finding-fixed" active={fixed > 0} />
      <Pill label="D" count={dismissed} testId="finding-dismissed" active={dismissed > 0} />
      <Pill label="Df" count={deferred} testId="finding-deferred" active={deferred > 0} />
    </span>
  );
}
